import { ContentType } from '@classification-testing/domain';
import { Volume, Photo, TextField } from '@soteria/design-system-ve';

/**
 * Get the appropriate icon component for a given content type
 */
export function getContentTypeIcon(contentType: ContentType) {
  switch (contentType) {
    case ContentType.AUDIO:
      return Volume;
    case ContentType.IMAGE:
      return Photo;
    case ContentType.TEXT:
    case ContentType.MIXED:
    default:
      return TextField;
  }
}
